var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"pa-3"},[_vm._v("Approve Events Log")]),_c('log-table',{attrs:{"itemList":_vm.eventLogApproval,"isLoading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }